// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_om-5";
export var filledCircle = "_om-4";
export var historyEntry = "_om-3";
export var messageSideLeft = "_om-1";
export var messageSideRight = "_om-2";
export var orderTrackingCarouselWrapper = "_om-6";
export var orderTrackingInfoContainer = "_om-0";